import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import { BackgroundImage, SectionWrapper } from "./styles.Section";

import { Content } from "../content/Content";
import { Logo } from "../header/Header";
import { Partners } from "../partners/Partners";

interface Props {
  id?: string;
  bigMargins?: boolean;
  backgroundColor?: string;
  backgroundImage?: string;
  setMenuId?: any;
  setMenuColor?: any;
}

export const StartSection: React.FC<Props> = ({
  backgroundColor,
  backgroundImage,
}) => {
  let renderedBackgroundImage = null;

  if (backgroundImage) {
    renderedBackgroundImage = <BackgroundImage src={backgroundImage} />;
  }

  return (
    <SectionWrapper
      backgroundColor={backgroundColor}
      zIndex="1000"
      style={{ height: "100%" }}
    >
      <Content style={{ height: "100%" }}>
        {renderedBackgroundImage}
        <Logo />
        <Partners />
      </Content>
    </SectionWrapper>
  );
};

export const Section: React.FC<Props> = ({
  id,
  bigMargins,
  backgroundColor,
  setMenuId,
  setMenuColor,
  children,
}) => {
  const [inViewRef, inView] = useInView();

  useEffect(() => {
    if (inView && setMenuId && setMenuColor) {
      setMenuId(id);
      setMenuColor(backgroundColor);
    }
  }, [inView]);

  return (
    <SectionWrapper backgroundColor={backgroundColor} id={id}>
      <Content bigMargins={bigMargins}>
        <div ref={inViewRef}></div>
        {children}
      </Content>
    </SectionWrapper>
  );
};
